'use client';

import type { ErrorInfo, ReactElement, ReactNode } from 'react';
import { cloneElement, Component } from 'react';
interface Props {
  children?: ReactNode;
  fallback: ReactElement<{
    resetBoundary: () => void;
    error: Error | null;
  }>;
  resetQuery?: () => void;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
const initialState: State = {
  hasError: false,
  error: null
};
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = initialState;
  }
  public static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error: error
    };
  }
  resetBoundary = () => {
    this.props.resetQuery?.();
    this.setState(initialState);
  };
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      return cloneElement(this.props.fallback, {
        resetBoundary: this.resetBoundary,
        error: this.state.error
      });
    }
    return this.props.children;
  }
}